import Controller from '@ember/controller';

export default class IncomeDrivenController extends Controller {
  queryParams = ['preserveScrollPosition'];

  preserveScrollPosition = true;
}
